import styled from "styled-components";

const SelectorContainer = styled.div`
  margin-left: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 30px;
	width: 30px;
	gap: 3px;
	cursor: pointer;
	span {
		width: 4px;
		height: 4px;
		background-color: #999999;
		border-radius: 50%;
	}
`;

export function Selector() {
	return (
		<SelectorContainer>
			<span className='small-circle'></span>
			<span className='small-circle'></span>
			<span className='small-circle'></span>
		</SelectorContainer>
	);
}